<template>
  <div :class="[prefix,`${prefix}-wrap`]">
    <div class="nav-body">
      <!-- 侧边导航 -->
      <CategoryNav></CategoryNav>
      <!-- 幻灯片 -->
      <div class="carousel-container">
        <Carousel
          loop
          :autoplay="carouselItems.length == 1 ? false : true "
          :autoplay-speed="speed"
          :arrow="carouselItems.length == 1 ? 'never' : 'hover'"
          :dots="carouselItems.length == 1 ? 'none' : 'inside'"
        >
          <CarouselItem
            v-for="(item, index) in carouselItems"
            :key="index"
          >
            <a :href="item.TargetUrl">
              <img :src="item.PictureUrl" />
            </a>
          </CarouselItem>
        </Carousel>
      </div>
      <!-- 鼎阳动态 -->
      <div class="user-info-news-list">
        <div class="user-info">
          <div class="welcome-info">
            <img src="static/img/header/avatar.png" />
            <div class="info">
              <p class="nickname">{{loginUserInfo.NickName}}</p>
              <p>您好，欢迎来到鼎阳商城~</p>
            </div>
          </div>
          <div class="btn-groups">
            <div v-if="!isLogged">
              <router-link to="/Login">
                <Button
                  type="info"
                  shape="circle"
                  size="small"
                >
                  登录
                </Button>
              </router-link>
              <router-link to="/Signup">
                <Button
                  type="warning"
                  shape="circle"
                  size="small"
                >
                  注册
                </Button>
              </router-link>
            </div>
            <div v-else>
              <router-link to="/quickOrder"> <Button
                  type="primary"
                  shape="circle"
                  size="small"
                  ghost
                >
                  快速下单
                </Button>
              </router-link>
            </div>
          </div>
        </div>
        <div class="news-list">
          <div class="news-title">
            <img src="static/img/news/site_news.png"  width="76px"/>
            <span
              @click="moreNews"
              class="more-news"
            >更多</span>
            <!-- <a
              target="_blank"
              class="more"
              href="/"
            ></a> -->
          </div>
          <ul class="news-content">
            <li
              v-for="(item,index) in pageList"
              :key="index"
              style="display:flex"
            >
            <img src="static/img/news/xinwen.png" width="30px" height="20px"/>
              <a
                class="news-item"
                :title="item.Title"
                href="/"
                target="_blank"
              >
                <router-link :to="'/news?Id=' + item.Id">
                  <p>{{item.Title}}</p>
                </router-link>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/styles/components/home/homeNav.scss';
import { mapState, mapActions } from 'vuex';
import CategoryNav from '@/components/category/CategoryNav';
import { enumBanner } from '@/utils/enum';
const prefix = 'cpt-home-nav';

export default {
  name: 'HomeNav',
  components: {
    CategoryNav
  },
  data () {
    return {
      prefix,
      carouselItems: [],
      pageList: [],
      speed: 4000
    };
  },
  computed: {
    ...mapState({
      isLogged: state => state.isLogged,
      loginUserInfo: state => state.loginUserInfo
    })
  },
  methods: {
    ...mapActions({
      getBannerByKey: 'getBannerByKey',
      newsGetPagedList: 'newsGetPagedList'
    }),
    moreNews () {
      this.$router.push({
        path: 'about',
        query: {
          item: '鼎阳动态'
        }
      });
    }
  },
  created () {
    this.getBannerByKey(enumBanner.web_Homepage_Top).then(result => {
      if (result.Success && result.Data) {
        this.speed = result.Data.Duration === 0 ? 4000 : result.Data.Duration * 1000;
        this.carouselItems = result.Data.Items || [];
      }
    });
    this.newsGetPagedList({
      ShowOnHomepage: 1,
      NewsType: 0,
      PageNo: 1,
      PageSize: 6,
      Keyword: '',
      Orderby: '',
      IsDesc: true

    }).then(res => {
      this.pageList = res.Data.List;
    });
    // this.getRecentNews()
    //   .then(result => {
    //     if (result.Success && result.Data && result.Data.List.length > 0) {
    //       this.recentNews = result.Data.List || [];
    //     }
    //   });
  },
  mounted () {
  },
  updated () {
  }
};
</script>

<style scoped lang='scss'>
@import '../../styles/base.scss';
</style>



// WEBPACK FOOTER //
// src/components/home/HomeNav.vue